import Bugsnag from "@bugsnag/js";

const BUGSNAG_API_KEY = "eda39e8427c9b740035212d88459d7b3";

let started = false;

/**
 * Ensures Bugsnag is started at most once per process (server) or per session (client).
 * Call this instead of Bugsnag.start() to avoid "Bugsnag.start() more than once" warnings.
 */
export function ensureBugsnagStarted(): void {
  if (started) return;
  started = true;
  Bugsnag.start({
    apiKey: BUGSNAG_API_KEY,
  });
}

/**
 * Report an error to Bugsnag with optional context, starting Bugsnag first if
 * needed. Background jobs and cron routes can run in a process where the root
 * loader never executed, so `Bugsnag.notify()` alone would silently drop them.
 */
export function notifyBugsnag(
  error: unknown,
  metadata?: Record<string, unknown>
): void {
  try {
    ensureBugsnagStarted();
    const normalized =
      error instanceof Error ? error : new Error(String(error ?? "Unknown error"));

    Bugsnag.notify(normalized, (event) => {
      if (metadata) event.addMetadata("context", metadata);
    });
  } catch (reportingError) {
    console.error("Failed to report error to Bugsnag:", reportingError);
  }
}

export { Bugsnag };
